<script>
    import SEO from '$components/SEO.svelte';
</script>

<SEO title='CondoGenius - Page Not Found | Condo Reviews for Toronto and GTA' description='Here to guide you for your next condo building search in Toronto, the Greater Toronto Area (GTA), and Canada.' />

<section id='hero' class='mt-6 bg-blue-500 w-full rounded-2xl py-[100px] px-5 md:px-10 text-white'>
    <h3 class='h1 text-4xl sm:text-5xl font-[600] mb-10'>
        Whoops! 404 Error
    </h3>
    <h4 class='text-xl sm:text-2xl'>
        Just like the <em>Highway</em> 404 at 5pm, <br>
        this page is going nowhere.
    </h4>
</section>

<section class='mt-10 sm:mt-20'>
    <h3 class='h3 text-lg sm:text-2xl font-semibold mb-5'>
        Not to worry. Here's some quick detours that <br />
        won't take 20 minutes to reroute:
    </h3>
    <ul>
        <li class='text-primary-500 text-base sm:text-xl py-0.5 hover:text-primary-500'><a href='/'>Homepage</a></li>
        <li class='text-primary-500 text-base sm:text-xl py-0.5 hover:text-primary-500'><a href='/me'>My Account</a></li>
        <li class='text-primary-500 text-base sm:text-xl py-0.5 hover:text-primary-500'><a href='/buildings/search'>Search Condo Reviews by Neighbourhood</a></li>
        <li class='text-primary-500 text-base sm:text-xl py-0.5 hover:text-primary-500'><a href='/buildings/toronto'>Search All Buildings</a></li>
        <li class='text-primary-500 text-base sm:text-xl py-0.5 hover:text-primary-500'><a href='/add-review'>Add a Condo Review</a></li>
    </ul>
</section>

<style>
    #hero {
        background: linear-gradient(180deg, rgba(59, 130, 246, 0.95), rgba(133, 198, 204, 0.65)), url($lib/images/skyline.jpg);
        background-size: cover;
        background-position-y: center;
    }
</style>
